import { types } from "../../types/types";
import { ESTADO_MEDICACION_310 } from "../../utils/constants";

const initialState = {
  items: [],
  loading: false,
  activosPorFecha: ESTADO_MEDICACION_310.VIGENTES
};

export const Medicamentos310Reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.empadronamientoMedicamentos310TraerStart:
      return {
        ...state,
        loading: true,
        items: []
      };
    case types.empadronamientoMedicamentos310TraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload
      };
    case types.empadronamientoMedicamentos310TraerError:
      return {
        ...state,
        loading: false,
      };
    case types.empadronamientoMedicamentos310SetActivosPorFecha: {
      return {
        ...state,
        activosPorFecha: action.payload
      }
    }
    default:
      return state;
  }
};
